import { render, staticRenderFns } from "./matricula_estudiante.vue?vue&type=template&id=a7e52856&scoped=true"
import script from "./matricula_estudiante.vue?vue&type=script&lang=js"
export * from "./matricula_estudiante.vue?vue&type=script&lang=js"
import style0 from "./matricula_estudiante.vue?vue&type=style&index=0&id=a7e52856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e52856",
  null
  
)

export default component.exports